import * as Yup from 'yup';
import { DictNote } from '@models';

export function useValidationSchema() {
  return Yup.object<DictNote>().shape({
    description: Yup.string().nullable().required(),
  });
}
